import * as React from 'react';
import { Card } from '@blueprintjs/core';
import UserDetails from '../../models/UserDetails';
import { RouteComponentProps } from 'react-router';
import { Form } from 'react-final-form';
import ResetPassword from '../../models/ResetPassword';
import { FormErrors } from 'src/util/FormErrors';
import FormTextbox from '../controls/forms/FormTextbox';
import { IRootState } from 'src/reducers';
import selectors from 'src/selectors';
import actions from 'src/actions';
import { connect } from 'react-redux';

interface IResetPasswordPageStateProps {
    user: UserDetails;
    passwordMatchFailed: boolean;
    isLoading: boolean;
    passwordErrors: string[];
}

export interface IResetPasswordPageDispatchProps {
    forgotPasswordReset: (payload: ResetPassword) => void;
    passwordsDoNotMatch: () => void;
}

type IResetPasswordPageProps = IResetPasswordPageStateProps & IResetPasswordPageDispatchProps & RouteComponentProps<{ guid: string }>;

class ResetPasswordPage extends React.Component<IResetPasswordPageProps> {
    validate = (values: ResetPassword) => {
        const errors: FormErrors<ResetPassword> = {};

        if (values.newPassword === undefined) {
            errors.newPassword = 'Password required';
        }

        if (values.firstPassword === undefined) {
            errors.firstPassword = 'Password required';
        }

        if (values.newPassword !== undefined && values.firstPassword !== undefined && values.firstPassword !== values.newPassword) {
            errors.newPassword = 'Passwords do not match';
            errors.firstPassword = 'Passwords do not match';
        }

        return errors;
    };

    handleSubmit = (resetPassword: ResetPassword) => {
        resetPassword.resetKey = this.props.match.params.guid;
        this.props.forgotPasswordReset(resetPassword);
    };

    public render() {
        return (
            <>
                <Card elevation={3} className="logo-panel">
                    <img src="/images/logo/logo.svg" />
                </Card>
                <Card elevation={3} className="login-panel">
                    <div className="login-form-header">Reset Your Password</div>
                    <ul>
                        {this.props.passwordErrors.map((error, index) => (
                            <div key={`error-${index}`}>{error}</div>
                        ))}
                    </ul>
                    <Form
                        onSubmit={this.handleSubmit}
                        validate={this.validate}
                        render={({ handleSubmit, pristine, invalid }) => {
                            return (
                                <form onSubmit={handleSubmit}>
                                    <FormTextbox isPassword={true} name="firstPassword" label="Enter New Password" />
                                    <FormTextbox isPassword={true} name="newPassword" label="Re-Enter Password" />
                                    <button type="submit" disabled={pristine || invalid} className="bp3-button pt-intent-primary submit-button">
                                        {this.props.isLoading ? 'Saving..' : 'Save'}
                                    </button>
                                </form>
                            );
                        }}
                    />
                </Card>
            </>
        );
    }
}

const mapStateToProps = (state: IRootState) => ({
    user: selectors.auth.user(state),
    passwordMatchFailed: selectors.profile.passwordMatchFailed(state),
    isLoading: selectors.profile.isLoading(state),
    passwordErrors: state.profile.passwordErrors,
});

const mapDispatchToProps: IResetPasswordPageDispatchProps = {
    passwordsDoNotMatch: () => actions.profile.passwordsDoNotMatch(),
    forgotPasswordReset: (payload: ResetPassword) => actions.profile.forgotPasswordReset(payload),
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordPage);



// WEBPACK FOOTER //
// ./src/components/login/ResetPasswordPage.tsx